/**
 * Docker networking helper for API fetches.
 *
 * Server-side (RSC, Route Handlers): uses Docker internal DNS -> http://backend:8000
 * Client-side (browser):             uses host-published port  -> http://localhost:8000
 */

export const INTERNAL_API_URL =
  process.env.INTERNAL_API_URL ?? "http://backend:8000";

export const PUBLIC_API_URL =
  process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8000";

export function getApiUrl() {
  return typeof window === "undefined" ? INTERNAL_API_URL : PUBLIC_API_URL;
}
